/* eslint-disable max-len */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {checkPasswordExpiryRequest, createNewPasswordRequest} from 'services/resetPassword.service'
import {get as _get} from 'lodash'

export interface resetPassword {
    isLoading: boolean
    error: any
    userDetails: any
    success: boolean
    errorMessage: string
    expiryPrecheck: any
    duplicate: any
    exists: boolean
}

const initialState: resetPassword = {
    isLoading: false,
    error: null,
    userDetails: null,
    success: false,
    errorMessage: '',
    expiryPrecheck: null,
    duplicate: null,
    exists: true
}

export const checkPasswordExpiryAction = createAsyncThunk(
    'resetPassword/checkPasswordExpiry',
    async (payload: any, {rejectWithValue}) => {
        try {
            const {data} = await checkPasswordExpiryRequest(payload)
            if (data?.response?.duplicate === true) {
                // const errorResponse = data.response;
                return rejectWithValue({
                    duplicate: data?.response?.duplicate,
                    errorMessage: ''
                })
            } else if (data?.response?.exist === false) {
                const checkIfEmailId = payload?.userID ? 'User ID' : 'Business Email ID'
                return rejectWithValue({
                    exist: data?.response?.exist,
                    errorMessage: `${checkIfEmailId} is not on record.`
                })
            } else if (data?.successFlag === false) {
                return rejectWithValue({
                    errorMessage: data?.errorList[0]?.text
                })
            }
            // return {data: data.response}
            return {data, userDetails: {email: payload?.email, userId: payload?.userID}, expiryPrecheck: data?.response}
        } catch (err: any) {
            if (err.response.status >= 400 && err.response.status < 500) {
                const msg: string =
                    String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
                return rejectWithValue(msg)
            } else if (err.response.status >= 500) {
                return rejectWithValue('Something went wrong')
            }
            return rejectWithValue(err.message)
        }
    }
)

export const createNewPasswordAction = createAsyncThunk(
    'resetPassword/createNewPassword',
    async (payload: any, {rejectWithValue}) => {
        try {
            const {data} = await createNewPasswordRequest(payload)
            return data
        } catch (err: any) {
            if (err.response.status >= 400 && err.response.status < 500) {
                const msg: string =
                    String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
                return rejectWithValue(msg)
            } else if (err.response.status >= 500) {
                return rejectWithValue('Something went wrong')
            }
            return rejectWithValue(err.message)
        }
    }
)

export const resetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder.addCase(checkPasswordExpiryAction.pending, (state) => {
            state.isLoading = true
            state.error = false
            state.expiryPrecheck = null
            state.duplicate = false
            state.exists = true
        })
        builder.addCase(checkPasswordExpiryAction.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = false
            state.userDetails = action?.payload?.userDetails
            state.expiryPrecheck = action?.payload?.expiryPrecheck
            state.duplicate = null
            state.exists = true
        })
        builder.addCase(checkPasswordExpiryAction.rejected, (state, action: any) => {
            state.isLoading = false
            state.error = true
            state.expiryPrecheck = null
            state.duplicate = action?.payload?.duplicate || action?.payload?.exist
            state.exists = action?.payload?.exist
        })
        builder.addCase(createNewPasswordAction.pending, (state) => {
            state.isLoading = true
            state.error = false
            state.success = false
        })
        builder.addCase(createNewPasswordAction.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = !action.payload.successFlag
            state.success = action.payload.successFlag
            state.errorMessage =
                !_get(action, 'payload.successFlag', true) &&
                _get(action, 'payload.errorList[0].text', 'Current Password is incorrect')
        })
        builder.addCase(createNewPasswordAction.rejected, (state) => {
            state.isLoading = false
            state.error = true
            state.success = false
            state.errorMessage = 'Something went wrong!'
        })
    }
})

export const {reducer: resetPasswordReducer} = resetPasswordSlice
